import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import Notifications from 'vue-notification';
import velocity from 'velocity-animate';
import "@/design/index.scss";
import store from '@/store/index';
import App from './App.vue';
import i18n from './i18n';
import "./registerServiceWorker";

import tinymce from 'vue-tinymce-editor';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueCurrencyInput from 'vue-currency-input';
import {initializeFirebase} from "@/services/pushNotification";
import VueCookies from 'vue-cookies';
import VueGtag from "vue-gtag";
// import * as Sentry from "@sentry/vue";
// import {Integrations} from "@sentry/tracing";
Vue.component('tinymce', tinymce);

Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
Vue.use(require('vue-scrollto'));
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(Notifications, {velocity});
Vue.use(require('vue-shortkey'));
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAp3zMwNATmu-75JQMwg5vK3pQ7KOeF4G8',
    libraries: 'places',
    region: 'VN',
    language: 'vi'
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts);

const options = {
  name: '_blank',
  specs: [],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    process.env.VUE_APP_LINK_PRINT,
    process.env.VUE_APP_LINK_PRINT_ORDER
    // 'http://localhost:8080/css/print.min.css'
  ],
}

Vue.use(VueHtmlToPaper, options);
Vue.use(VueCurrencyInput);
Vue.use(VueCookies);
Vue.use(VueGtag, {
  config: {id: process.env.VUE_APP_GOOGLE_ANALYTIC ? process.env.VUE_APP_GOOGLE_ANALYTIC : 'G-5L187P65BH'}
});

// if (process.env.VUE_APP_ENV === "PROD") {
//   Sentry.init({
//     Vue,
//     dsn: "https://74d5df94b5a3487dada8527bfc43994d@o197834.ingest.sentry.io/5821328",
//     integrations: [new Integrations.BrowserTracing()],
//     tracesSampleRate: 1.0,
//   });
// }
initializeFirebase();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
